import * as yup from "yup";

const today = new Date();
today.setHours(0, 0, 0, 0);

const eighteenCheck = new Date();
eighteenCheck.setFullYear(eighteenCheck.getFullYear() - 18);

export const signUpValidationSchema = yup.object({
  title: yup.string().required("Title is required"),
  givenName: yup
    .string()
    .matches(/^[A-Za-z \-']*$/, "Please enter valid name")
    .max(40)
    .required("A given name is required"),
  familyName: yup
    .string()
    .matches(/^[A-Za-z \-']*$/, "Please enter valid name")
    .max(40)
    .required("A surname is required"),
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup
    .string("Enter your password")
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase and One Number"
    ),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match"),
  phone: yup
    .string()
    .matches(
      /^\({0,1}((0|\+61)(2|4|3|7|8)){0,1}\){0,1}( |-){0,1}[0-9]{2}( |-){0,1}[0-9]{2}( |-){0,1}[0-9]{1}( |-){0,1}[0-9]{3}$/,
      "Must be a valid Australian phone number with area code +61"
    )
    .required("A phone number is required"),
  nmi: yup.string().min(10).max(11),
});

export const paymentValidationSchema = yup.object({
  bsb: yup.array().of(
    yup
      .string()
      .required("BSB must contain 6 digits")
      .matches(/^[0-9]{3}[--]?[0-9]{3}$/, "BSB must contain 6 digits only")
  ),
  accountNumber: yup
    .array()
    .of(
      yup
        .string()
        .min(6, "Account number must be at least 6 digits")
        .max(9, "Account number must be no more than 9 digits")
    ),
  dateOfBirth: yup
    .date()
    .nullable()
    .required("Please enter your DOB")
    .typeError("Invalid date. Must be in format dd/mm/yyyy")
    .max(eighteenCheck, "You must be 18 years or older to sign up."),
  idType: yup.string().required("Identity Type is required"),
  isDriversLicence: yup.boolean(),
  idNumberDriversLicence: yup.string().when("isDriversLicence", {
    is: true,
    then: yup
      .string()
      .required("Drivers Licence number is required")
      .matches(
        /^[a-zA-Z0-9]{6,12}$/,
        "Licence Number must be at least 6 alphanumeric characters."
      ),
  }),
  isPassport: yup.boolean(),
  idNumberPassport: yup.string().when("isPassport", {
    is: true,
    then: yup
      .string()
      .required("Passport number is required")
      .matches(
        /^[A-Za-z0-9]{8,12}$/,
        "Passport Number must must be at least 8 Alphanumeric characters."
      ),
  }),
  isMedicare: yup.boolean(),
  idNumberMedicare: yup.string().when("isMedicare", {
    is: true,
    then: yup
      .string()
      .required("Medicare Number is required")
      .matches(
        /^[2-6]{1}[0-9]{10}$/,
        "Medicare number must contain 11 digits."
      ),
  }),
  idExpiry: yup.date().when("isMedicare", {
    is: false,
    then: yup
      .date()
      .nullable()
      .typeError("Invalid date. Must be in format dd/mm/yyyy")
      .required("ID expiry date is required")
      .min(today, "Date cannot be in the past."),
    // .transform((curr, orig) => (orig === "" ? null : curr)),
    // .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
  }),
});
